module.exports = new __parcel__URL__("DPG.f2a21246.png").toString();